const condo_sec1_part3Object = payload => {
  return {
    type: "condosec1part3",
    payload
  };
};

export default condo_sec1_part3Object;
